import classNames from 'classnames'
import { forwardRef } from 'react'

import styles from './brand.module.scss'
import { BrandElement, BrandProps } from './common'
import { SvgJusia as Logo } from './svg/jus-ia'

export const BrandJusIa = forwardRef<BrandElement, BrandProps>(function BrandJusIa(
  props,
  forwardedRef
) {
  const { className, onlySymbol = false, version = 'positive', ...rest } = props

  const classes = classNames(
    styles.root,
    {
      [styles.positive]: version === 'positive',
      [styles.negative]: version === 'negative',
    },
    className
  )

  return (
    <Logo onlySymbol={onlySymbol} role="img" {...rest} className={classes} ref={forwardedRef} />
  )
})
